import {
  AfterViewInit,
  Component,
  computed,
  inject,
  output,
  signal
} from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { ClassService } from '../../../../services/class.service'
import { Navbar } from '../../../common/navbar/navbar.component'
import { Modal } from 'bootstrap'
import { AbstractUpcomingClass } from '../../../../modal/class.modal'
import { LanguageService, Locale } from '../../../../services/language.service'
import { LeaveRequestService } from '../../../../services/leave-request.service'
import { commonUtil } from '../../../../utils/common.util'
import { LeaveRequest } from '../../../../modal/leave-request.modal'

@Component({
  selector: 'add-leave-request',
  imports: [Navbar, TranslatePipe, ReactiveFormsModule],
  templateUrl: './add-leave-request.component.html',
  styleUrl: './add-leave-request.component.css'
})
export class AddLeaveRequest implements AfterViewInit {
  private modal?: Modal
  private classService = inject(ClassService)
  private lrService = inject(LeaveRequestService)
  private langService = inject(LanguageService)
  private translateService = inject(TranslateService)
  addRequestCallback = output<LeaveRequest>()
  classes = signal<AbstractUpcomingClass[]>([])
  classOptions = computed(() => {
    return this.classes().map((clazz) => {
      let format =
        this.langService.getCurrentLocale() === Locale.EN
          ? 'd MMMM (EEE)'
          : 'L月d日 (EEEE)'
      let labelDate = this.langService.dateTransform(
        new Date(clazz.date!),
        format
      )
      return {
        value: clazz.id,
        label: `${labelDate} ${clazz.shortTimeStart()} - ${clazz.shortTimeEnd()}`
      }
    })
  })
  type = new FormControl('casual')
  classSelect = new FormControl('')
  isDataLoading = true
  isRequestAdding = false

  getData() {
    this.isDataLoading = true
    this.classes.set([])
    this.classService.getCurrentUserClasses().subscribe({
      next: (classes) => {
        this.classes.set(classes)
        this.classSelect.setValue(classes[0].id + '')
        this.isDataLoading = false
      },
      error: () => (this.isDataLoading = false)
    })
  }

  doAddRequest() {
    this.isRequestAdding = true
    let type = this.type.value! as 'casual' | 'sick'
    let classId = Number.parseInt(this.classSelect.value!)
    this.lrService.addLeaveReqeust(type, classId).subscribe({
      next: (req) => {
        commonUtil.alert(
          this.translateService.instant(
            'app.leaveRequest.leaveRequestAddedSuccessfully'
          ),
          'success'
        )
        this.isRequestAdding = false
        this.addRequestCallback.emit(req)
        this.hide()
      },
      error: () => (this.isRequestAdding = false)
    })
  }

  show() {
    this.getData()
    this.modal?.show()
  }

  hide() {
    this.modal?.hide()
  }

  ngAfterViewInit(): void {
    this.modal = Modal.getOrCreateInstance('#addReqeustModal')
  }
}
